export default __webpack_public_path__ + "static/media/i_am_teacher.2001957e.png";